
export default {
  data() {
    return {
      dialog: false,
      form: {
        endereco: {},
      },
      itemsCPF: [
        { title: 'Score' },
        { title: 'Dados cadastrais' },
        { title: 'Dados restritivos' },
        { title: 'Renda presumida' },
        { title: 'Indicador de decisão' },
        { title: 'Limite de parcela sugerida' },
        { title: 'E muito mais.' },
      ],
      itemsCNPJ: [
        { title: 'Score' },
        { title: 'Dados cadastrais' },
        { title: 'Dados restritivos' },
        { title: 'Indicadores positivos' },
        { title: 'quadro societário' },
        { title: 'Limite de crédito' },
        { title: 'E muito mais.' },
      ],
    }
  },
  methods: {
    goToRegister() {
      this.$router.push('/solicitacao-consulta-credito')
    },
  },
}
